import React, { Component, useState, useEffect } from "react";
import "./Sidebar.css";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { isLoggedIn, logout } from "../webapi/AuthService";
import withAuthorization from "../withAuthorization";
import { Translation } from "react-i18next";
import Subject from "@mui/icons-material/Subject";
import Videocam from "@mui/icons-material/Videocam";
import Today from "@mui/icons-material/Today";
import Share from "@mui/icons-material/Share";
import WifiTethering from "@mui/icons-material/WifiTethering";
import Settings from "@mui/icons-material/Settings";
import FolderIcon from "@mui/icons-material/Folder";
import SearchIcon from "@mui/icons-material/Search";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import PlaylistPlay from "@mui/icons-material/PlaylistPlay";

const Bar = props => {
  const [showRundown, setShowRundown] = useState(false);
  const [showMam, setShowMam] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showLive, setShowLive] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [node, setNode] = useState(null);

  const location = useLocation();
  useEffect(() => {
    updateSidebar(props.allPersonRoles);
  }, [props.allPersonRoles]);

  const updateSidebar = allPersonRoles => {
    if (allPersonRoles.includes("superAdmin")) {
      setShowRundown(true);
      setShowMam(true);
      setShowLive(true);
      setShowAdmin(true);
      setShowSearch(true);
    } else {
      setShowRundown(
        allPersonRoles.includes("rundownRead") ||
          allPersonRoles.includes("rundownWrite") ||
          allPersonRoles.includes("rundownFull") ||
          allPersonRoles.includes("rundownZebraStudio") ||
          allPersonRoles.includes("rundownAdmin")
      );
      setShowMam(
        allPersonRoles.includes("mamView") ||
          allPersonRoles.includes("mamEdit") ||
          allPersonRoles.includes("mamUpload") ||
          allPersonRoles.includes("mamDownload") ||
          allPersonRoles.includes("mamDelete") ||
          allPersonRoles.includes("mamAdmin")
      );
      setShowSearch(
        allPersonRoles.includes("searchMetadata") ||
          allPersonRoles.includes("searchVideo") ||
          allPersonRoles.includes("searchDownload")
      );
    }
  };

  const isCurrentPath = (path, exact = false) => {
    if (exact) {
      return location.pathname.toLowerCase() === path.toLowerCase();
    }
    return location.pathname.toLowerCase().startsWith(path.toLowerCase());
  };

  return (
    <Translation>
      {t => (
        <div className="sidebar" ref={node => setNode(node)}>
          <Link to={"/"}>
            <div className="SidebarLogo">
              <img
                src={require("/images/zebra-icon.png")}
                className="img-fluid"
                alt="zebra"
                title={t("Dashboard")}
              />
            </div>
          </Link>

          {showRundown ? (
            <React.Fragment>
              <div className="MainNavItem__active">
                <Link to={"/rundown/agenda"}>
                  {isCurrentPath("/rundown/agenda") ? (
                    <div>
                      <Today className="LinkIconActive" />
                      <div className="LinkIconActiveArrow"></div>
                      <span className="LinkIconTitleActive">{t("Agenda")}</span>
                    </div>
                  ) : (
                    <div className="LinkMenu">
                      <Today className="LinkIcon" />
                      <span className="LinkIconTitle">{t("Agenda")}</span>
                    </div>
                  )}
                </Link>
                <Link to={"/rundown"}>
                  {isCurrentPath("/rundown", true) ? (
                    <div>
                      <WifiTethering className="LinkIconActive" />
                      <div className="LinkIconActiveArrow"></div>
                      <span className="LinkIconTitleActive">
                        {t("Rundown")}
                      </span>
                    </div>
                  ) : (
                    <div className="LinkMenu">
                      <WifiTethering className="LinkIcon" />
                      <span className="LinkIconTitle">{t("Rundown")}</span>
                    </div>
                  )}
                </Link>
                <Link to={"/rundown/autocue"}>
                  {isCurrentPath("/rundown/autocue") ? (
                    <div>
                      <Subject className="LinkIconActive" />
                      <div className="LinkIconActiveArrow"></div>
                      <span className="LinkIconTitleActive">
                        {t("Autocue")}
                      </span>
                    </div>
                  ) : (
                    <div className="LinkMenu">
                      <Subject className="LinkIcon" />
                      <span className="LinkIconTitle">{t("Autocue")}</span>
                    </div>
                  )}
                </Link>{" "}
                <Link to={"/rundown/regie"}>
                  {isCurrentPath("/rundown/regie") ? (
                    <div>
                      <Videocam className="LinkIconActive" />
                      <div className="LinkIconActiveArrow"></div>
                      <span className="LinkIconTitleActive">{t("Regie")}</span>
                    </div>
                  ) : (
                    <div className="LinkMenu">
                      <Videocam className="LinkIcon" />
                      <span className="LinkIconTitle">{t("Regie")}</span>
                    </div>
                  )}
                </Link>{" "}
                <Link to={"/rundown/export"}>
                  {isCurrentPath("/rundown/export") ? (
                    <div>
                      <Share className="LinkIconActive" />
                      <div className="LinkIconActiveArrow"></div>
                      <span className="LinkIconTitleActive">{t("Export")}</span>
                    </div>
                  ) : (
                    <div className="LinkMenu">
                      <Share className="LinkIcon" />
                      <span className="LinkIconTitle">{t("Export")}</span>
                    </div>
                  )}
                </Link>{" "}
                <Link to={"/rundown/feeds"}>
                  {isCurrentPath("/rundown/feeds") ? (
                    <div>
                      <RssFeedIcon className="LinkIconActive" />
                      <div className="LinkIconActiveArrow"></div>
                      <span className="LinkIconTitleActive">{t("Feeds")}</span>
                    </div>
                  ) : (
                    <div className="LinkMenu">
                      <RssFeedIcon className="LinkIcon" />
                      <span className="LinkIconTitle">{t("Feeds")}</span>
                    </div>
                  )}
                </Link>
              </div>
              <Link to={"/rundown/playlist"}>
                  {isCurrentPath("/rundown/playlist") ? (
                    <div>
                      <PlaylistPlay
                        className="LinkIconActive"
                        style={{ color: "#2395F2" }}
                      />
                      <div className="LinkIconActiveArrow"></div>
                      <span className="LinkIconTitleActive">
                        {t("Playlist")}
                      </span>
                    </div>
                  ) : (
                    <div className="LinkMenu">
                      <PlaylistPlay
                        className="LinkIcon"
                        style={{ color: "#2395F2" }}
                      />
                      <span className="LinkIconTitle">{t("Playlist")}</span>
                    </div>
                  )}
                </Link>
            </React.Fragment>
          ) : null}

          {showMam ? (
            <Link to={"/mam"}>
              {isCurrentPath("/mam") ? (
                <div>
                  <FolderIcon
                    className="LinkIconActive"
                    style={{ color: "#f54ea2" }}
                  />
                  <div className="LinkIconActiveArrow"></div>
                  <span className="LinkIconTitleActive">{t("MAM")}</span>
                </div>
              ) : (
                <div className="LinkMenu">
                  <FolderIcon
                    className="LinkIcon"
                    style={{ color: "#f54ea2" }}
                  />
                  <span className="LinkIconTitle">{t("MAM")}</span>
                </div>
              )}
            </Link>
          ) : null}

          {showSearch ? (
            <Link to={"/search"}>
              {isCurrentPath("/search") ? (
                <div>
                  <SearchIcon className="LinkIconActiveSearch" />
                  <div className="LinkIconActiveArrow"></div>
                  <span className="LinkIconTitleActive">{t("Search")}</span>
                </div>
              ) : (
                <div className="LinkMenu">
                  <SearchIcon className="LinkIconSearch" />
                  <span className="LinkIconTitle">{t("Search")}</span>
                </div>
              )}
            </Link>
          ) : null}

          {showLive ? (
            <Link to={"/live"}>
              {isCurrentPath("/live") ? (
                <div className="LinkMenu">
                  <div className="LinkIconLive">{t("Live")}</div>
                  <div className="LinkIconActiveArrow"></div>
                  <span className="LinkIconTitleActive">{t("Live")}</span>
                </div>
              ) : (
                <div className="LinkMenu">
                  <div className="LinkIconLive">{t("Live")}</div>
                  <span className="LinkIconTitle">{t("Live")}</span>
                </div>
              )}
            </Link>
          ) : null}

          {showAdmin ? (
            <Link to={"/admin/account"}>
              {isCurrentPath("/admin") ? (
                <div>
                  <Settings className="LinkIconActiveSettings" />
                  <div className="LinkIconActiveArrow"></div>
                  <span className="LinkIconTitleActive">{t("Admin")}</span>
                </div>
              ) : (
                <div className="LinkMenu">
                  <Settings className="LinkIconSettings" />
                  <span className="LinkIconTitle">{t("Admin")}</span>
                </div>
              )}
            </Link>
          ) : null}
            <div>
              <img src="/images/logos/zndznd_logo.png" className="sidebarImage" />
            </div>

        </div>
      )}
    </Translation>
  );
};

class Sidebar extends Component {
  constructor() {
    super();
    this.state = {
      showSidebar: true
    };
    this.updateViewState = this.updateViewState.bind(this);
    this.openSidebar = this.openSidebar.bind(this);
    this.closeSidebar = this.closeSidebar.bind(this);
    this.userSession = this.userSession.bind(this);
  }
  updateViewState() {
    if (!this.state.mobileView && document.documentElement.clientWidth < 1300) {
      this.setState({
        showSidebar: false
      });
      window.removeEventListener("mousedown", this.closeSidebar, false);
    } else if (document.documentElement.clientWidth > 1300) {
      this.setState({
        showSidebar: true
      });
      window.removeEventListener("mousedown", this.closeSidebar, false);
    }
  }

  componentWillMount() {
    this.updateViewState();
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateViewState);
    window.addEventListener("focus", this.userSession);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateViewState);
  }

  userSession() {
    if (!isLoggedIn()) {
      logout();
    }
  }

  openSidebar() {
    this.setState({
      showSidebar: true
    });
    window.addEventListener("mousedown", this.closeSidebar, false);
  }

  closeSidebar(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.setState({
      showSidebar: false
    });
    window.removeEventListener("mousedown", this.closeSidebar, false);
  }

  render() {
    return (
      <div>
        <a className="sidebarToggle" onClick={this.openSidebar}>
          <img
            src={require("/images/icons/menu.png")}
            className="img-fluid"
            alt="zebra"
          />
        </a>
        {this.state.showSidebar && (
          <div ref={node => (this.node = node)}>
            <Bar allPersonRoles={this.props.allPersonRoles} />
          </div>
        )}
      </div>
    );
  }
}

export default withAuthorization(Sidebar);
